import { DropdownMenu } from "@bigbinary/neeto-atoms";
import { hyphenate } from "neetocist";
import { withT } from "neetocommons/react-utils";

import MenuItem from "./MenuItem";

const Submenu = withT(({ t, label, menuItems = [] }) => (
  <DropdownMenu.SubMenu
    {...{ label }}
    triggerProps={{ "aria-haspopup": "menu" }}
    contentProps={{
      "aria-label": t("neetoMolecules.moreDropdown.submenuAriaLabel", {
        label,
      }),
    }}
  >
    {menuItems.map(({ isVisible = true, key, ...itemProps }) => {
      if (!isVisible) return null;

      return (
        <MenuItem
          key={key ?? hyphenate(itemProps.label || "menu-item")}
          {...itemProps}
        />
      );
    })}
  </DropdownMenu.SubMenu>
));

export default Submenu;
